var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { name: "form" },
      on: {
        click: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _c("c-input", {
        directives: [
          {
            name: "validator",
            rawName: "v-validator",
            value: { required: true },
            expression: "{ required: true }"
          }
        ],
        attrs: {
          label: "Razão social",
          name: "name",
          validation: _vm.$hasError("name")
        },
        model: {
          value: _vm.form.name,
          callback: function($$v) {
            _vm.$set(_vm.form, "name", $$v)
          },
          expression: "form.name"
        }
      }),
      _vm._v(" "),
      _c("c-input", {
        directives: [
          {
            name: "validator",
            rawName: "v-validator",
            value: {
              required: true,
              pattern: /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i
            },
            expression:
              "{ required: true, pattern: /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\\.[A-Z0-9-]+)+$/i }"
          }
        ],
        attrs: {
          label: "E-mail",
          name: "email",
          validation: _vm.$hasError("email")
        },
        model: {
          value: _vm.form.email,
          callback: function($$v) {
            _vm.$set(_vm.form, "email", $$v)
          },
          expression: "form.email"
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          on: {
            click: function($event) {
              _vm.$validator.validateForm("form")
            }
          }
        },
        [_vm._v("Validate")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }